import Search from '../components/Search';

export default function Main() {
  return (
    <>
      <Search />
    </>
  );
}
